import { request } from '../../utils'

export function normalize(selection, success, error) {
  request({
    url: '/api/site/search',
    data: {
      search: '',
      search_in: 'photos albums live site',
      selection,
      size: 200,
    },
    success,
    error,
  })
}

export function search(data, success, error) {
  return request({
    url: '/api/site/search',
    data,
    success,
    error,
  })
}

export function listVideos(data, success, error) {
  const d = {
    size: 100,
    include_unpublished_p: 1,
    ...data,
  }
  return request({
    url: '/api/photo/list',
    data: d,
    success,
    error,
  })
}

export function listEvents(data = {}, success = undefined, error = undefined) {
  const d = {
    size: 100,
    include_private_p: 1,
    stream_preview_p: 1,
    ...data,
  }
  return request({
    url: '/api/live/list',
    data: d,
    success,
    error,
  })
}

export function listAlbums(success) {
  return request({
    url: '/api/album/list',
    data: {
      size: 200,
      include_hidden_p: 1,
    },
    success,
  })
}
